import { StandardEvents } from '@shopify/events';

class AhsPackageSummary extends HTMLElement {
  #scope;
  #revision = 0;

  connectedCallback() {
    this.#scope = this.closest('.shopify-section, dialog');
    this.#scope?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.#revision += 1;
    this.#scope?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
    const revision = ++this.#revision;
    event.promise
      .then(({ detail }) => {
        if (!this.isConnected || revision !== this.#revision || !detail?.html) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
        const selector = `ahs-package-summary[data-block-id="${CSS.escape(this.dataset.blockId)}"]`;
        const updated = detail.html.querySelector(selector);
        if (!updated) return;
        this.replaceChildren(...Array.from(updated.childNodes, (node) => node.cloneNode(true)));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('Package details could not update.', error);
      });
  };
}

if (!customElements.get('ahs-package-summary')) {
  customElements.define('ahs-package-summary', AhsPackageSummary);
}
